import { LoadingOutlined } from "@ant-design/icons";

const GradientButton = ({ children, className, loading = false, ...rest }) => {
  return (
    <button
      className={`flex items-center justify-center gap-x-4 py-2 px-6 bg-gradient-to-l from-darkerOrange via-darkOrange to-lightOrange hover:bg-gradient-to-bl text-white drop-shadow-md rounded-full ${className}`}
      {...rest}
    >
      {children}
      {loading && <LoadingOutlined style={{ color: "orange" }} />}
    </button>
  );
};

export default GradientButton;
